import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import {KEYBOARD_SHORTCUTS} from './consts';

import styles from './keyboard-shortcuts-modal.module.css';

export function ShortcutsGrid() {
    return (
        <div className={styles['shortcuts-grid']}>
            {KEYBOARD_SHORTCUTS.map((category) => (
                <StackLegacy key={category.category} spacing={8}>
                    <div className='mb-4'>
                        <Body color='dark'>{category.category}</Body>
                    </div>
                    {category.shortcuts.map((shortcut) => (
                        <StackLegacy
                            alignCenter={true}
                            isHorizontal={true}
                            spacing={8}
                            key={
                                Array.isArray(shortcut.keys)
                                    ? shortcut.keys.join('-')
                                    : shortcut.keys
                            }
                        >
                            {Array.isArray(shortcut.keys) ? (
                                shortcut.keys.map((key, index) => (
                                    <kbd
                                        key={key}
                                        className={
                                            index < shortcut.keys.length - 1
                                                ? styles['shortcut-key-multi']
                                                : styles['shortcut-key']
                                        }
                                    >
                                        {key}
                                    </kbd>
                                ))
                            ) : (
                                <kbd className={styles['shortcut-key']}>{shortcut.keys}</kbd>
                            )}
                            <Body size='small'>{shortcut.description}</Body>
                        </StackLegacy>
                    ))}
                </StackLegacy>
            ))}
        </div>
    );
}
